<template>
  <div class="chart-linear" ref="chartDom" ></div>
</template>

<script setup>
  import * as echarts from 'echarts';
  import { ref, computed, onMounted, watch  } from "vue"

  const chartDom = ref(null)

  const props = defineProps({
    labels: {
      type: Array,
      default: []
    },
    data: {
      type: Array,
      default: []
    }
  })

  watch(() => props.labels, () => {
    charInit()
  })
  
  watch(() => props.data, () => {
    charInit()
  })
const option = computed(() => {
  return {
    markLine: {
      data: [
        {
          xAxis: 20,
          yAxis: 64.566477,
          label: {
            formatter: '64.566477',
            position: 'top',
            backgroundColor: 'rgba(97, 189, 255, 0.7)',
            borderColor: '#61b3ff',
            borderWidth: 1,
            padding: [5, 10]
          },
          lineStyle: {
            color: '#61b3ff'
          }
        }
      ]
    },
    tooltip: {
      trigger: 'axis'
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: props.labels,
      axisTick: {
        alignWithLabel: true,
        interval: 0  // Asegura que se muestre cada tick
      },
      axisLabel: {
        interval: 0  // Forzamos a que se muestren todas las etiquetas
      }
    },
    yAxis: {
      type: 'value'
    },
    grid: {
      left: '.5%',
      right: '.8%',
      bottom: '.5%',
      top: '3%',
      containLabel: true
    },
    series: [
      {
        data: props.data,
        type: 'line',
        smooth: .2,
        showAllSymbol: true,  // Muestra el símbolo para cada punto
        symbolSize: 4,
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0.3, color: 'rgba(28, 150, 237, 0.88)' },
            { offset: 1, color: 'rgba(97, 189, 255, 0)' }
          ])
        }
        // Se puede eliminar 'connectNulls' ya que 0 no es null.
      }
    ]
  };
});


  const charInit = () => {

    var myChart = echarts.init(chartDom.value);
    myChart.setOption(option.value, 'dark');

    console.log('charInit', option.value)
    console.log('labels', props.labels)

  }

  onMounted(() => {
    charInit()
  })

</script>
<style setup>
.chart-linear {
  width: 98%;
  height: 360px;
  box-sizing: border-box
}
</style>